import { useLayoutEffect } from "react";
import { setPublicRestaurantAnonScope } from "@/integrations/supabase/client";

/**
 * Sets `x-restaurant-id` on the browser Supabase client while mounted / while id is set.
 * Use on public routes that rely on `request_restaurant_id()` in RLS (booking, gift, order).
 */
export function useSyncPublicRestaurantAnonScope(
  restaurantId: string | null | undefined
): void {
  useLayoutEffect(() => {
    if (restaurantId) setPublicRestaurantAnonScope(restaurantId);
    return () => setPublicRestaurantAnonScope(null);
  }, [restaurantId]);
}
